export interface DatiLookup {
    stagioni: ItemDatiLookup[];
    modelli: ItemDatiLookup[];
    fasi: ItemDatiLookup[];
    consegne: ItemDatiLookup[];
    colori: ItemDatiLookup[];
    lineeVendita: ItemDatiLookup[];
    modelliDistinte: ItemDatiLookup[];
    coloriDistinte: ItemDatiLookup[];
    //componentiRigheDistinte: ItemDatiLookup[];
    //coloriComponentiRigheDistinte: ItemDatiLookup[];
    tipologieAvanzamentoProduzione: ItemDatiLookup[];
    umRigheDistinte: ItemDatiLookup[];
    modelliSchedeTecniche: string[];
}

export interface ItemDatiLookup {
    id: string;
    desc: string;
}

export const DatiLookupDefault: DatiLookup = {
    stagioni: [],
    modelli: [],
    fasi: [],
    consegne: [],
    lineeVendita: [],
    colori: [],
    modelliDistinte: [],
    coloriDistinte: [],
    //componentiRigheDistinte: [],
    //coloriComponentiRigheDistinte: [],
    tipologieAvanzamentoProduzione: [],
    modelliSchedeTecniche: [],
    umRigheDistinte: [{
        id: "m",
        desc: "metri"
    },
    {
        id: "mm",
        desc: "millimetri"
    },
    {
        id: "nr",
        desc: "numero pezzi"
    },
    {
        id: "gr",
        desc: "grammi"
    },
    {
        id: "Kg",
        desc: "Kilogrammi"
    },
    ]
};